import {
	ref,
	computed,
	Ref,
} from 'vue';

const ITEMS_PER_VIEW = 1;

export const useArrowNavigation = ({
	productsContainer,
	productsLength,
}: {
	productsContainer: Ref<HTMLElement | null>;
	productsLength: number;
}) => {
	const currentIndex = ref(0);

	const isLeftDisabled = computed(() => currentIndex.value <= 0);
	const isRightDisabled = computed(() => currentIndex.value >= productsLength - ITEMS_PER_VIEW);

	const handleArrowClick = ({ direction }: { direction: 'left' | 'right' }) => {
		const container = productsContainer.value;

		if (!container) return;

		const productElements = [...container.children] as HTMLElement[];

		if (!productElements.length) return;

		if (direction === 'left') {
			if (isLeftDisabled.value) return;

			currentIndex.value = Math.max(0, currentIndex.value - 1);
		} else {
			if (isRightDisabled.value) return;

			currentIndex.value = Math.min(productsLength - ITEMS_PER_VIEW, currentIndex.value + 1);
		}

		const targetElement = productElements[currentIndex.value];
		const targetPosition = targetElement.offsetLeft - container.offsetLeft;

		container.scrollTo({
			left: targetPosition,
			behavior: 'smooth',
		});
	};

	return {
		handleArrowClick,
		isLeftDisabled,
		isRightDisabled,
	};
};
